import React from 'react';
import { Skeleton } from '@mui/material';

const IFrameSkeleton: React.FC = () => {
    return (
        <Skeleton
            animation="wave"
            variant="rounded"
            height={400}
            sx={{
                width: '100%',
                borderRadius: 2,
            }}
        />
    );
};

export default IFrameSkeleton;
